// Translation: Register > Landing > Form > TOS dialog (Arabic)
export default Object.freeze({})
